import { render, staticRenderFns } from "./productDetailRefund.vue?vue&type=template&id=22b71ea2&scoped=true"
import script from "./productDetailRefund.vue?vue&type=script&lang=js"
export * from "./productDetailRefund.vue?vue&type=script&lang=js"
import style0 from "./productDetailRefund.vue?vue&type=style&index=0&id=22b71ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b71ea2",
  null
  
)

export default component.exports